import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { dirFor, LOCALES } from "./locales";
import { loadAndSetLocale } from "./config";

/** Current locale + setter. Keeps <html lang>/<html dir> in sync (RTL-ready). */
export function useLocale() {
  const { i18n } = useTranslation();
  const code = i18n.language;

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("lang", code);
    root.setAttribute("dir", dirFor(code));
  }, [code]);

  const setLocale = useCallback(async (next: string) => {
    await loadAndSetLocale(next);
  }, []);

  return { code, dir: dirFor(code), locales: LOCALES, setLocale };
}
